<app-bx-share-side-form
    #docSideForm
    (submitForm)="saveAndClose()"
    (closeForm)="cancel()"
    [enableClickOut]="false"
    [navList]="navList"
    [fromCRFQ]="true"
    (activeForm)="switchForm($event)">
    <h4 formHeading class="modal-title">RESPONSE FROM {{ recipient?.name }}</h4>

    <ng-container statuses>
        <h4>Status</h4>
        <app-bx-lifecycle id="status" name="status" ngDefaultControl [bxLifeCycleInput]="requestStates" [(ngModel)]="requestStatus">
        </app-bx-lifecycle>
    </ng-container>

    <ng-container rightPanel>
        <div class="row">
            <app-rfq-response-details
                *ngIf="recipient"
                [hidden]="selectedNavItem !== rfqResponseComponents.Details && !layoutService.isMobile()"
                [recipient]="recipient">
            </app-rfq-response-details>

            <app-rfq-response-costingitems
                [hidden]="selectedNavItem !== rfqResponseComponents.CostingItems && !layoutService.isMobile()"
                [recipient]="recipient"
                (selectedCountEvent)="countUpdated(1, $event)">
            </app-rfq-response-costingitems>

            <app-rfq-response-messages
                [hidden]="selectedNavItem !== rfqResponseComponents.Messages && !layoutService.isMobile()"
                [recipient]="recipient"
                (messageCountEvent)="countUpdated(2, $event)">
            </app-rfq-response-messages>

            <app-rfq-response-attachments
                [hidden]="selectedNavItem !== rfqResponseComponents.Attachments && !layoutService.isMobile()"
                [recipient]="recipient"
                (attachmentCountEvent)="countUpdated(3, $event)">
            </app-rfq-response-attachments>
        </div>
    </ng-container>

    <ng-container validation>
        <app-side-form-validation [formStatus]="formStatus" [successMessage]="'Success'" [inProgressMessage]="'Saving'">
        </app-side-form-validation>
    </ng-container>

    <ng-container button-grp>
        <button class="btn-bx-secondary-stroked" type="button" (click)="cancel()">Cancel</button>
        <button class="btn-bx-primary ml-2" type="submit">Save & Close</button>
    </ng-container>
</app-bx-share-side-form>
